<template>
  <v-app>
    <NavigationHeaderComponent />
    <router-view />
    <FooterComponent />
  </v-app>
</template>

<script>
// @ is an alias to /src
import NavigationHeaderComponent from "@/components/NavigationHeaderComponent.vue"
import FooterComponent from "@/components/FooterComponent.vue"
import EventBus from "./common/EventBus"

export default {
	name: "App",
	components: {
		NavigationHeaderComponent,
		FooterComponent,
	},
	methods: {
		logout() {
			this.$store.dispatch("auth/logout")
			this.$router.push("/login")
		},
	},
	mounted() {
		EventBus.on("logout", () => {
			this.logout()
		})
	},
	beforeDestroy() {
		EventBus.remove("logout")
	},
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
